import * as type from '../ActionTypes';

const initialState = {
  jobs: {},
  invitedCoder: {},
  clientInviteJob: [],
  recommendedCoder: [],
  allRecommendedCoder: {},
  routeCount: null,
  loading: false,
  clientInviteLoading: false,
  error: null
};

export default function jobs(state = initialState, action: any) {
  switch (action.type) {
    case type.GET_JOB_REQUEST_INIT:
      return {
        ...state,
        loading: true
      };
    case type.GET_JOB_REQUEST:
      return {
        ...state,
        loading: true
      };
    case type.GET_JOB_SUCCESS:
      return {
        ...state,
        loading: false,
        jobs: action.jobs
      };
    case type.GET_JOB_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.message || 'Oops, something went wrong!'
      };
    case type.GET_RECOMMENDEDCODER_SUCCESS:
      return {
        ...state,
        loading: false,
        recommendedCoder: action.recommendedCoder,
        allRecommendedCoder: action.allRecommendedCoder
      };
    case type.GET_RECOMMENDEDCODER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.message || 'Oops, something went wrong!'
      };
    case type.GET_INVITEDCODER_SUCCESS:
      return {
        ...state,
        loading: false,
        invitedCoder: action.invitedCoder
      };
    case type.GET_INVITEDCODER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error || 'Oops, something went wrong!'
      };
    case type.GET_CLIENT_INVITE_JOB_REQUEST:
      return {
        ...state,
        clientInviteLoading: true
      };
    case type.GET_CLIENT_INVITE_JOB_SUCCESS:
      return {
        ...state,
        clientInviteLoading: false,
        clientInviteJob: action.clientInviteJob
      };
    case type.GET_CLIENT_INVITE_JOB_FAILURE:
      return {
        ...state,
        clientInviteLoading: false,
        error: action.error || 'Oops, something went wrong!'
      };
    case type.GET_ROUTE_COUNT_SUCCESS:
      return {
        ...state,
        loading: false,
        routeCount: action.routeCount
      };
    case type.RESET_ROUTE_COUNT:
      return {
        ...state,
        loading: false,
        routeCount: null
      };
    case type.RESET_JOBS:
      return {
        ...state,
        jobs: {},
        loading: false,
        error: null
      };
    case type.CLEAR_RECOMMENDED_JOBS:
      return {
        ...state,
        recommendedCoder: [],
        loading: false,
        error: null
      };
    default:
      return state;
  }
}
